import { newStorage } from './storage';

const couponsTableStorage = newStorage('TABLE_COUPONS');

export default couponsTableStorage;
